/**
 * `triggerClassName` for the shared InfoTooltip's inline info triggers. The
 * `.a11y-tap-44` overlay in styles.css extends the click and tap target
 * beyond the small glyph.
 */
export const INFO_TRIGGER_CLASS = "a11y-tap-44 h-6 w-6 text-[14px]";

/** `triggerClassName` for the header's info button, with the same `.a11y-tap-44` overlay. */
export const HEADER_INFO_TRIGGER_CLASS =
  "a11y-tap-44 border-haze size-[37px] border-[1.5px] text-[13px]";
